module.exports = __webpack_public_path__ + "static/media/westinchennai10.b24633ba.jpg";